<template>
<w-frame-popup-content-template :default-content="false">
  <div class="frame-table" style="height:100%;padding:25px;" slot="content">
    <!-- 로그인 기록 -->
    <el-tabs class="tab-button" style="height:100%;" v-model="subActiveTab">
      <el-tab-pane label="로그인 기록" name="loginHist">
        <el-row class="title-bar" type="flex" justify="space-between">
          <el-date-picker style="width:228px;" v-model="histDateRange" type="daterange" :range-separator="defaultDateRangeOptions.rangeSeparator" :start-placeholder="defaultDateRangeOptions.startPlaceholder" :end-placeholder="defaultDateRangeOptions.endPlaceholder" :default-time="defaultDateRangeOptions.defaultTime"
            :picker-options="defaultDateRangeOptions.pickerOptions" :clearable="false" />
          <div>
            <el-button size="small" @click="onClickExportExcepLoginHist"><img src="@/assets/img/icons/excel.png" style="position:relative;top:3px;left:-2px">엑셀 출력</el-button>
            <w-header-search-button @click="loginShowSearchTool = !loginShowSearchTool"></w-header-search-button>
          </div>
        </el-row>
        <el-table-wrapper style="height:calc(100% - 40px);" fit-height :total="loginTotal" :data="loginDatas" :columns="loginColumns" :pagination="true" :show-search-tool="loginShowSearchTool" :show-custom-header="true"
        ref="loginTable" :remote="true" :column-default="columnDefault" @condition-change="onChangeTable" >
        </el-table-wrapper>
      </el-tab-pane>
      <!-- 메뉴 접근 기록 -->
      <el-tab-pane label="메뉴 접근 기록" name="menuAccessHist">
        <el-row class="title-bar" type="flex" justify="space-between">
          <el-date-picker style="width:228px;" v-model="histDateRange" type="daterange" :range-separator="defaultDateRangeOptions.rangeSeparator" :start-placeholder="defaultDateRangeOptions.startPlaceholder" :end-placeholder="defaultDateRangeOptions.endPlaceholder" :default-time="defaultDateRangeOptions.defaultTime"
              :picker-options="defaultDateRangeOptions.pickerOptions" :clearable="false" />
          <div>
            <el-button size="small" @click="onClickExportExcepMenuAccessHist"><img src="@/assets/img/icons/excel.png" style="position:relative;top:3px;left:-2px">엑셀 출력</el-button>
            <w-header-search-button @click="accessShowSearchTool = !accessShowSearchTool"></w-header-search-button>
          </div>
        </el-row>
        <el-table-wrapper style="height:calc(100% - 40px);" fit-height :total="menuTotal" :data="menuAccessDatas" :columns="menuAccessColumns" :pagination="true" :show-search-tool="accessShowSearchTool" :show-custom-header="true"
        ref="menuAccessTable" :remote="true" :column-default="columnDefault" @condition-change="onChangeTable">
        </el-table-wrapper>
      </el-tab-pane>
    </el-tabs>
  </div>
</w-frame-popup-content-template>
</template>

<script>
import { defaultDateRangeOptions, getDateToString } from '@/utils/date';
import { EMPTY_TEXT, getValueAfterCheckEmpty } from '@/utils/string';
import { isNil } from 'lodash';
import userAPI from '@/api/frame/user';
import { columnDefault } from '@/constants/table';
import WFramePopupContentTemplate from './FramePopupContentTemplate';

export default {
  name: 'WAccessHistTab',
  components: {
    WFramePopupContentTemplate,
  },
  props: {
    activeTab: {
      type: String,
    },
  },
  data() {
    return {
      menuTotal: 0,
      loginTotal: 0,
      loginShowSearchTool: false,
      accessShowSearchTool: false,
      subActiveTab: 'loginHist',
      loginDatas: [],
      columnDefault,
      loginColumns: [
        {
          prop: 'loginDatetime',
          label: '로그인 시각',
          sortable: true,
          formatter: this.convertDatetime,
        },
        {
          prop: 'connectIpaddress',
          label: '로그인 IP',
          remoteProp: 'connect_ipaddress',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'logoutDatetime',
          label: '로그아웃 시각',
          sortable: true,
          formatter: this.convertDatetime,
        },
      ],
      menuAccessDatas: [],
      menuAccessColumns: [
        {
          prop: 'menuName',
          remoteProp: 'menu_name',
          label: '메뉴명',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'connectIpaddress',
          label: '로그인 IP',
          remoteProp: 'connect_ipaddress',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'checkDatetime',
          label: '접근시각',
          remoteProp: 'check_datetime',
          sortable: true,
          searchable: true,
          searchType: 'date',
          formatter: this.convertDatetime,
        },
      ],
      params: {},
      histDateRange: [],
      defaultDateRangeOptions,
    };
  },
  watch: {
    histDateRange: {
      handler(date) {
        this.params.startDatetime = date[0];
        this.params.endDatetime = date[1];
        if (this.activeTab === 'accessHist') {
          this.loadStore();
        }
      },
    },
    subActiveTab: {
      handler() {
        if (this.activeTab === 'accessHist') {
          this.loadStore();
        }
      },
    },
    activeTab: {
      handler(val) {
        if (val === 'accessHist') {
          this.loadStore();
        }
      },
    },
  },
  created() {
    this.histDateRange = [new Date().setHours(0, 0, 0, 0), new Date().setHours(23, 59, 59, 59)];
  },
  methods: {
    /**
     * [loadStore 데이터 로드]
     * @author {Yang}
     */
    loadStore() {
      if (this.$refs.loginTable === undefined) {
        this.$nextTick(() => {
          if (this.subActiveTab === 'menuAccessHist') {
            this.accessLoadStore();
          } else {
            this.loginLoadStore();
          }
        });
      } else if (this.subActiveTab === 'menuAccessHist') {
        this.accessLoadStore();
      } else {
        this.loginLoadStore();
      }
    },
    /**
     * [loginLoadStore 로그인 기록 데이터 가져오기]
     * @author {Yang}
     */
    loginLoadStore() {
      const tableParams = this.$refs.loginTable.getParameter();
      const params = {
        ...this.params,
        ...tableParams,
      };
      userAPI.getLoginHistoryList(params).then((result) => {
        if (result.data.success === true) {
          this.loginDatas = result.data.data;
          this.loginTotal = result.data.total;
        }
      });
    },
    /**
     * [accessLoadStore 메뉴접근 이력 데이터 가져오기]
     * @author {name}
     * @return {[Yang]} [description]
     */
    accessLoadStore() {
      const tableParams = this.$refs.menuAccessTable.getParameter();
      const params = {
        ...this.params,
        ...tableParams,
      };
      userAPI.getMenuAccessHistoryList(params).then((result) => {
        if (result.data.success === true) {
          this.menuAccessDatas = result.data.data;
          this.menuTotal = result.data.total;
        }
      });
    },
    /**
     * [getTableValueAfterCheckEmpty 테이블 빈값 확인]
     * @author {Yang}
     */
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    /**
     * [convertDatetime 테이블 날짜 포맷 설정]
     * @author {Yang}
     */
    convertDatetime(row, column, value) {
      if (isNil(value)) {
        return EMPTY_TEXT;
      }
      return getDateToString(value, 'YYYY/MM/DD (ddd) HH:mm');
    },
    /**
     * [onClickExportExcepLoginHist 로긴 엑셀출력]
     * @author {Yang}
     * @return {[type]} [description]
     */
    onClickExportExcepLoginHist() {
      // const tableParams = this.$refs.loginTable.getParameter(); // TODO 추후 일괄적으로 적용 예정
      const params = {
        ...this.params,
        // searchParams: tableParams.searchParams,
      };
      userAPI.exportExcelLoginHistoryList(params);
    },
    /**
     * [onClickExportExcepMenuAccessHist 메뉴 접근 엑셀출력]
     * @author {Yang}
     * @return {[type]} [description]
     */
    onClickExportExcepMenuAccessHist() {
      // const tableParams = this.$refs.menuAccessTable.getParameter();
      const params = {
        ...this.params,
        // ...tableParams,
      };
      userAPI.exportExcelMenuAccessHistoryList(params);
    },
    onChangeTable() {
      this.loadStore();
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/frame/components/popup/AccessHistTab.vue